// Shared identity: HTML, QR, downloadable contact and 3D lettering use these values.
export const profile = {
	firstName: "Simone",
	lastName: "Piteo",
	role: "Tech Lead",
	city: "Milan",
	country: "Italy",
	email: "me@simonepiteo.com",
	contactFileName: "simone-piteo.vcf",
	cvUrl: "cv-simone-piteo-2026.pdf",
	githubUrl: "https://github.com/simonepiteo",
	linkedinUrl: "https://www.linkedin.com/in/simonepiteo/",
};

export const fullName = `${profile.firstName} ${profile.lastName}`;
export const location = `${profile.city}, ${profile.country}`;
export const emailUrl = `mailto:${profile.email}`;

export const site = {
	copyrightYear: 2026,
	language: "en",
	title: `${fullName} — ${profile.role}`,
	description: `A small world of pixels. About, CV and contact details for ${fullName}.`,
	aboutHeading: "A little about me",
	bio: "I graduated from Politecnico di Milano and currently work as a Technical Leader at IBM. I connect application architecture with software development, and build personal projects that turn everyday needs into useful, practical software tools.",
	projectsHeading: "Things I build",
	contactsHeading: "Get in touch",
	project: {
		name: "ATO Clipboard Manager",
		url: "https://github.com/simonepiteo/ato-clipboard-manager",
		description: "An open-source clipboard manager for macOS.",
		action: "View on GitHub",
	},
};
